const OptionOrderType = ({ index, type = 'number', prefix = '', chartColor = '#E8634D', textColor = '#FFFFFF', optionNumContainer }: {
  index: number;
  type?: 'number' | 'letter';
  prefix?: string;
  chartColor?: string;
  textColor?: string;
  optionNumContainer?: string;
}) => {
  const optionLabel = type === 'number' ? index + 1 : String.fromCharCode(65 + index);
  const label = prefix ? `${prefix}${optionLabel}` : optionLabel;
  const minLabelWidth = `${Math.max(3, String(label).length + 3)}ch`;
  return (
    <div
      style={{ color: textColor, minWidth: minLabelWidth }}
      className={`px-1 h-full 2xl:min-w-18 xl:min-w-13.5 min-w-12 shrink-0 grid place-items-center rounded-md overflow-hidden ${prefix ? 'w-auto' : optionNumContainer}`}>
      <span className="whitespace-nowrap px-1.5 font-Inter  2xl:text-4xl xl:text-3xl text-3xl">
        {label}
      </span>
    </div>
  );
};

export default OptionOrderType;
